exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.badge[data-v-29fd5e67] {\n    cursor: pointer;\n}\nlabel[data-v-29fd5e67] {\n    font-style: italic;\n}\n\n", ""]);

// exports
